import { render, staticRenderFns } from "./OptionShowBudgetsTab.vue?vue&type=template&id=4de5b0df"
import script from "./OptionShowBudgetsTab.vue?vue&type=script&lang=ts"
export * from "./OptionShowBudgetsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports